import React from 'react';

export interface BadgeProps {
    /** Badge style variant */
    variant?: 'default' | 'accent' | 'muted' | 'outline';
    /** Badge content */
    children: React.ReactNode;
    /** Additional CSS classes */
    className?: string;
}

const variantStyles = {
    default: 'bg-surface-light text-muted border border-border',
    accent: 'bg-accent/10 text-accent border border-accent/30',
    muted: 'bg-white/5 text-muted border border-border',
    outline: 'bg-transparent text-white border border-white/20',
};

/**
 * Reusable Badge/Pill component for labels and tags.
 * Commonly used for announcements and feature highlights.
 */
export function Badge({
    variant = 'default',
    children,
    className = '',
}: BadgeProps) {
    return (
        <span
            className={`inline-flex items-center gap-2 text-[13px] px-3 py-1 rounded-full ${variantStyles[variant]} ${className}`}
        >
            {children}
        </span>
    );
}
